import React, { FunctionComponent } from 'react';
import classNames from 'classnames';

import { IconProps, SizeOptions } from '@hcs/types';

import { addOptionalEngagementProps } from '../utils/engagement-props.utils';
const SIZE_LOOKUP: Record<SizeOptions, number> = {
  xxs: 12,
  xs: 14,
  sm: 16,
  md: 24,
  lg: 30,
  xl: 60,
  xxl: 90,
};
const sizeInput = (size: IconProps['size']): number => {
  if (typeof size === 'number') {
    return size;
  }
  return SIZE_LOOKUP[size || 'md'];
};

export const useIcon = (
  Svg: FunctionComponent<
    React.SVGProps<SVGSVGElement> & {
      title?: string | undefined;
    }
  >,
  { dataHcName, className, size: sizeProp, color, ...props }: IconProps,
) => {
  const size = sizeInput(sizeProp);
  const { ref, ...restProps } = props;
  return (
    <div
      data-hc-name={dataHcName}
      {...addOptionalEngagementProps(restProps)}
      className={classNames('IconContainer', className)}
      style={{
        color: color ? `var(--${color})` : undefined,
        fontSize: size,
        width: size,
        height: size,
      }}
    >
      <Svg style={{ width: size, height: size }} {...restProps} />
    </div>
  );
};
